module.exports = __webpack_public_path__ + "static/img/icon_program.4a0037d4.svg";